// extracted by mini-css-extract-plugin
export default {"container":"AddedAppliance_container__hWPGA","viewContainer":"AddedAppliance_viewContainer__S61Ne","editContainer":"AddedAppliance_editContainer__uxIsI"};